function Input(props) {
  console.log(props);
  return (
    <>
      {props.control === "input" && (
        <label className="form-control w-full max-w-xs">
          <div className="label gap-3 h-12">
            <span className="label-text">
              {props.label}
              {props.required && (
                <span className="text-custom-blue font-bold text-base">*</span>
              )}
            </span>
          </div>
          <input
            className={`input input-bordered w-full max-w-xs ${
              props.touched && !props.valid && "invalid"
            }`}
            type={props.type}
            id={props.id}
            value={props.value}
            placeholder={props.placeholder}
            onChange={(e) =>
              props.onChange(
                props.id,
                e.target.value,
                e.target.files,
                props.index
              )
            }
            onBlur={(e) =>
              props.onBlur(
                props.id,
                e.target.value,
                e.target.files,
                props.index
              )
            }
          />
          {props.touched && !props.valid && (
            <span className="label-text-alt text-red-500">{props.message}</span>
          )}
        </label>
      )}

      {props.control === "textarea" && (
        <label className="form-control">
          <div className="label">
            <span className="label-text">
              {`${props.label}${props.required && "*"}`}
            </span>
            {props.touched && !props.valid && (
              <span className="label-text-alt text-red-500">
                {props.message}
              </span>
            )}
          </div>
          <textarea
            className={`textarea textarea-bordered h-40 ${
              props.touched && !props.valid && "invalid"
            }`}
            placeholder={props.label}
            id={props.id}
            value={props.value}
            onChange={(e) => props.onChange(props.id, e.target.value)}
            onBlur={(e) =>
              props.onBlur(
                props.id,
                e.target.value,
                e.target.files,
                props.index
              )
            }
          ></textarea>
        </label>
      )}

      {props.control === "image" && (
        <label className="form-control w-full max-w-xs">
          <div className="label">
            <span className="label-text">
              <span className="label-text">{props.label}</span>
            </span>
          </div>
          <input
            type="file"
            className="file-input file-input-bordered w-full max-w-xs"
            id={props.id}
            onChange={(e) =>
              props.onChange(props.id, e.target.value, e.target.files)
            }
            onBlur={(e) =>
              props.onChange(props.id, e.target.value, e.target.files)
            }
          />
        </label>
      )}
    </>
  );
}

export default Input;
